import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import apiService from '../services/api';

const TOAST_HIDE_MS = 5000;

const Home = ({ user }) => {
  const [activeActivities, setActiveActivities] = useState([]);
  const [userActivities, setUserActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [totalPoints, setTotalPoints] = useState(0);
  // 商城订单提醒Toast相关
  const [shopOrdersCount, setShopOrdersCount] = useState(0);
  const [showOrderToast, setShowOrderToast] = useState(false);

  useEffect(() => {
    // 获取待处理订单数量（仅管理员/工会委员可见）
    const fetchPendingOrders = async () => {
      try {
        const res = await apiService.getPendingOrdersCount();
        setShopOrdersCount(res.data.pending_count || res.data.count || 0);
      } catch (e) {
        setShopOrdersCount(0);
      }
    };
    if (user && (user.role === 'admin' || user.role === 'union')) {
      fetchPendingOrders();
    }

    const fetchData = async () => {
      try {
        setLoading(true);
        
        // 获取当前可报名的活动
        const activitiesResponse = await apiService.getActiveActivities();
        // 获取用户报名的活动
        const userActivitiesResponse = await apiService.getUserActivities();
        setUserActivities(userActivitiesResponse.data);
        // 只显示报名开放且未报名活动
        const registeredIds = new Set(userActivitiesResponse.data.map(ua => ua.activity_id));
        const now = new Date();
        const filtered = activitiesResponse.data.filter(a => {
          const endTime = new Date(a.end_time);
          // 已结束的活动直接排除
          if (endTime < now) return false;
          // 只显示报名开放且未报名
          return a.enroll_open && !registeredIds.has(a.id);
        });
        setActiveActivities(filtered);
        
        // 获取用户积分
        const pointsResponse = await apiService.getUserPoints();
        setTotalPoints(pointsResponse.data.total_points);
        
      } catch (err) {
        setError('获取数据失败');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    
    fetchData();
  }, []);

  // 监听订单数和用户，满足条件弹出toast
  useEffect(() => {
    if (
      shopOrdersCount > 0 &&
      user &&
      (user.role === 'admin' || user.role === 'union')
    ) {
      setShowOrderToast(true);
      const timer = setTimeout(() => setShowOrderToast(false), TOAST_HIDE_MS);
      return () => clearTimeout(timer);
    }
  }, [shopOrdersCount, user]);

  if (loading) {
    return (
      <div className="text-center my-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-2">加载中...</p>
      </div>
    );
  }

  return (
    <>
      {/* 商城订单提醒Toast */}
      {showOrderToast && user && (user.role === 'admin' || user.role === 'union') && (
        <div style={{
          position: 'fixed',
          right: 24,
          bottom: 24,
          zIndex: 9999,
          minWidth: 320,
          maxWidth: 400,
          boxShadow: '0 8px 32px rgba(80,80,120,0.18)',
          borderRadius: 16,
          background: 'linear-gradient(135deg, #f7fafc 60%, #e0eaff 100%)',
          border: 'none',
          padding: 0
        }}>
          <div style={{ display: 'flex', alignItems: 'center', padding: '18px 18px 12px 18px' }}>
            <div style={{
              background: 'linear-gradient(135deg,#5f7cff 60%,#8adfff 100%)',
              borderRadius: '50%',
              width: 44,
              height: 44,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: 16,
              boxShadow: '0 2px 8px rgba(95,124,255,0.10)'
            }}>
              <i className="bi bi-bag-check-fill" style={{ fontSize: 24, color: '#fff' }}></i>
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 18, fontWeight: 600, color: '#313a4e' }}>
                <span style={{ fontSize: 24, color: '#3a6cff', fontWeight: 700 }}>{shopOrdersCount}</span>
                <span style={{ marginLeft: 8 }}>待处理订单</span>
              </div>
              <div style={{ fontSize: 13, color: '#6c7a99', marginTop: 2 }}>请及时处理商城订单</div>
            </div>
            <button
              type="button"
              className="btn-close ms-2"
              aria-label="Close"
              onClick={() => setShowOrderToast(false)}
              style={{ filter: 'invert(0.5)', opacity: 0.6, transition: 'opacity 0.2s' }}
              onMouseOver={e => e.currentTarget.style.opacity = 1}
              onMouseOut={e => e.currentTarget.style.opacity = 0.6}
            ></button>
          </div>
          <div style={{ padding: '0 18px 16px 78px', marginTop: -8 }}>
            <Link
              to="/admin/shop-orders"
              className="btn btn-outline-primary btn-sm"
              style={{ borderRadius: 20, fontWeight: 500, padding: '4px 18px' }}
            >
              立即前往
            </Link>
          </div>
        </div>
      )}
      <div className="container mt-4 fade-in">
      <div className="row">
        <div className="col-md-12">
          <div className="jumbotron p-4 rounded" style={{ 
            background: 'linear-gradient(135deg, rgba(108,92,231,0.1) 0%, rgba(253,121,168,0.1) 100%)',
            borderLeft: '5px solid var(--dopamine-purple)',
            boxShadow: '0 4px 15px rgba(0,0,0,0.05)'
          }}>
            <h1 className="display-4 page-title">NEDL职工之家</h1>
            <p className="lead">您可以在这里参与各种活动并获取积分。</p>
            <hr className="my-4" style={{ opacity: 0.2 }} />
            <p>当前有 <span className="badge bg-primary">{activeActivities.length}</span> 个可报名的活动。</p>
            {user ? (
              <Link to="/activities" className="btn btn-primary btn-lg">浏览所有活动</Link>
            ) : (
              <div>
                <Link to="/login" className="btn btn-primary btn-lg me-2">登录</Link>
                <Link to="/register" className="btn btn-outline-primary btn-lg">注册</Link>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="row mb-4">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <h2 className="card-title">欢迎, {user.nickname || user.username}!</h2>
              <p className="card-text">您当前的积分: <span className="badge bg-success">{totalPoints} 分</span></p>
              {user.role === 'admin' && (
                <div className="mt-3">
                  <Link to="/admin" className="btn btn-primary">进入管理面板</Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="row mb-4">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header bg-primary text-white">
              <h4 className="mb-0">当前可报名活动</h4>
            </div>
            <div className="card-body">
              {error && <div className="alert alert-danger">{error}</div>}
              {activeActivities.length === 0 ? (
                <p className="text-center">当前没有可报名的活动</p>
              ) : (
                <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-4">
                  {activeActivities.map(activity => (
                    <div className="col" key={activity.id}>
                      <div className="card h-100 activity-card">
                        <img 
                          src={activity.thumbnail} 
                          className="card-img-top" 
                          alt={activity.name}
                          onError={e => {
                            if (!e.target.__hasError) {
                              e.target.src = '/images/activity_default.png';
                              e.target.__hasError = true;
                            }
                          }}
                        />
                        <div className="card-body d-flex flex-column">
                          <h5 className="card-title">{activity.name}</h5>
                          <p className="card-text flex-grow-1">{activity.description}</p>
                          <div className="mt-auto">
                            <p className="card-text">
                              <span className="badge bg-info me-2">{activity.points} 积分</span>
                            </p>
                            <Link to={`/activities/${activity.id}`} className="btn btn-outline-primary w-100">
                              查看详情
                            </Link>
                          </div>
                        </div>
                        <div className="card-footer text-muted">
                          <div className="d-flex justify-content-between align-items-center">
                            <small>
                              <i className="bi bi-calendar-event me-1"></i>
                              {new Date(activity.start_time).toLocaleDateString()}
                            </small>
                            <small>
                              <i className="bi bi-clock me-1"></i>
                              {new Date(activity.end_time).toLocaleDateString()}
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              <div className="text-end mt-3">
                <Link to="/activities" className="btn btn-primary">查看所有活动</Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header bg-primary text-white">
              <h4 className="mb-0">我的报名记录</h4>
            </div>
            <div className="card-body">
              {error && <div className="alert alert-danger">{error}</div>}
              {userActivities.length === 0 ? (
                <p className="text-center">您还没有报名任何活动</p>
              ) : (
                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>活动名称</th>
                        <th>积分</th>
                        <th>状态</th>
                        <th>报名时间</th>
                        <th>操作</th>
                      </tr>
                    </thead>
                    <tbody>
                      {userActivities.map(ua => (
                        <tr key={ua.id}>
                          <td>{ua.activity?.name}</td>
                          <td>{ua.activity?.points}</td>
                          <td>
                            {ua.status === 'registered' && <span className="badge bg-warning">已报名</span>}
                            {ua.status === 'attended' && <span className="badge bg-info">已参加</span>}
                            {ua.status === 'completed' && <span className="badge bg-success">已完成</span>}
                            {ua.status === 'deleted' && <span className="badge bg-danger">已取消</span>}
                          </td>
                          <td>{new Date(ua.registered_at).toLocaleString()}</td>
                          <td>
                            <Link to={`/activities/${ua.activity_id}`} className="btn btn-sm btn-outline-primary">
                              查看活动
                            </Link>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
              <div className="text-end mt-3">
                <Link to="/my-activities" className="btn btn-primary">查看所有报名</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>);
};

export default Home;
